import { useEffect } from 'react';

import useDesks from '@/hooks/useDesks';
import useHomeCheckList, { AccountUserPrefsEnum } from '@/hooks/useHomeCheckList';
import useOverViewUsage from '@/modules/analytics/hooks/useOverviewUsage';
import { formatDate, subMonthsFromNow } from '@/util/dateUtils';

const useHomeInit = () => {
  const { desks } = useDesks();
  const { accountUserChecklist, markAsComplete } = useHomeCheckList();

  useEffect(() => {
    if (desks && desks.length > 0) {
      markAsComplete(AccountUserPrefsEnum.ENVIRONMENT_SETUP, true);
    }
  }, [accountUserChecklist, desks, markAsComplete]);

  const messages = useOverViewUsage({
    intervalProps: {
      startDate: formatDate(subMonthsFromNow(3), 'yyyy-MM-dd'),
      endDate: formatDate(new Date(), 'yyyy-MM-dd'),
    },
    skip: accountUserChecklist[AccountUserPrefsEnum.RECEIVE_MESSAGES],
    skipPrevious: true,
  });

  useEffect(() => {
    if (messages?.data?.counts && +messages.data.counts > 99) {
      markAsComplete(AccountUserPrefsEnum.RECEIVE_MESSAGES);
    }
  }, [accountUserChecklist, messages?.data?.counts, markAsComplete]);
};

export default useHomeInit;
